import { render, staticRenderFns } from "./wordEditorTier.vue?vue&type=template&id=1512d1fc&scoped=true&"
import script from "./wordEditorTier.vue?vue&type=script&lang=js&"
export * from "./wordEditorTier.vue?vue&type=script&lang=js&"
import style0 from "./wordEditorTier.vue?vue&type=style&index=0&lang=less&"
import style1 from "./wordEditorTier.vue?vue&type=style&index=1&id=1512d1fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512d1fc",
  null
  
)

export default component.exports